import {Strings} from '@zvne/fe-framework/dist/presentation/language/strings';

const en = {
    loginRequiredTitle: 'Login required',
    loginRequiredBody: 'Login is required to access this page.',
    login: 'Login',
    unauthorizedTitle: 'Unauthorized',
    unauthorizedBody: 'You do not have permission to access this page.',
    currentlyLoggedInAs: 'Currently logged in as:',
    logout: 'Logout'
};

const hr = {
    loginRequiredTitle: 'Potrebna prijava',
    loginRequiredBody: 'Za pristup ovoj stranici potrebna je prijava.',
    login: 'Prijava',
    unauthorizedTitle: 'Pristup nije odobren',
    unauthorizedBody: 'Nemate dozvolu za pristup ovoj stranici.',
    currentlyLoggedInAs: 'Trenutno ste prijavljeni kao:',
    logout: 'Odjava'
};

export const strings: Strings<typeof en> = {en, hr};
